module.exports = __webpack_public_path__ + "img/sp-sort-button-up.4569bee4.svg";